import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomToast from 'components/common/CustomToast';
import {
  deleteUserAPIToken,
  resetDeleteUserAPITokenState,
} from '../../store/user/userAction';

import Button from 'components/common/Button';

import { toast } from 'react-toastify';
import './index.css';

const ShowTokenCredentials = (props) => {
  const dispatch = useDispatch();
  const deleteUserAPITokenState = useSelector(
    (state) => state.user.deleteUserAPIToken
  );

  if (deleteUserAPITokenState.success) {
    dispatch(resetDeleteUserAPITokenState());
    toast(() => (
      <CustomToast toastType="success" message="Access key deactivated" />
    ));
    props.closeModal();
  }

  if (deleteUserAPITokenState.error) {
    toast(() => (
      <CustomToast toastType="error" message="Something went wrong" />
    ));
    dispatch(resetDeleteUserAPITokenState());
  }

  return (
    <div className="show-api-credentials-container">
      <div className="mx-10 my-10">
        <div className="text-xl text-center text-red-600">
          {' '}
          Are you sure you want to deactivate your access key ?
        </div>
        <div className="mt-4 px-4 flex items-center justify-center">
          <Button
            intent="error"
            loading={deleteUserAPITokenState.loading ? true : false}
            showSpinner={true}
            onClick={() => {
              dispatch(deleteUserAPIToken(props?.credential?.access_key));
            }}
          >
            Yes
          </Button>
          <Button
            intent="primary"
            extendClass="ml-4"
            onClick={props.closeModal}
          >
            No
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShowTokenCredentials;
